import type { ApiFilters, Filters } from './types';

export function getDefaults() : Filters {
  return {
    activityTypes: [],
    brokers: [],
    dateRange: {
      min: null,
      max: null,
    },
    page: 1,
    parentTypes: [],
    query: '',
  };
}

export function readDeepLinkedFilters(): Filters | null {
  const params = new URLSearchParams(window.location.search);
  const query = params.get('query');
  const activityType = params.get('activity_type');
  const parentType = params.get('parent_type');
  const dateFrom = params.get('date_from');
  const dateTo = params.get('date_to');

  if (query == null && activityType == null && parentType == null && dateFrom == null && dateTo == null) {
    return null;
  }

  return {
    ...getDefaults(),
    activityTypes: activityType ? [activityType] : [],
    dateRange: { min: dateFrom, max: dateTo },
    parentTypes: parentType ? [parentType] : [],
    query: query ?? '',
  };
}

export function hasFilters(filters: Filters) {
  return (
    !!filters.activityTypes.length ||
    !!filters.brokers.length ||
    !!filters.dateRange.min ||
    !!filters.dateRange.max ||
    !!filters.parentTypes.length ||
    !!filters.query.trim().length
  );
}

export function serializeFilters(filters: Filters): ApiFilters {
  const apiFilters: ApiFilters = {
    activityTypeFilter: filters.activityTypes,
    broker: filters.brokers,
    page: filters.page,
    parentTypeFilter: filters.parentTypes,
    query: filters.query,
  };

  if (filters.dateRange.min) {
    apiFilters['date_range[gte]'] = filters.dateRange.min;
  }

  if (filters.dateRange.max) {
    apiFilters['date_range[lte]'] = filters.dateRange.max;
  }

  return apiFilters;
}
